import type * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Tabela.
 *
 * Bez Radiksa, bo natywny `<table>` jest już dostępny i nawigowalny — primityw
 * niesie tu tylko styl i jedną rzecz, o której łatwo zapomnieć: **poziome
 * przewijanie wewnątrz własnego kontenera**. Tabela z kilkoma kolumnami na
 * telefonie inaczej rozpycha całą stronę i przewija się w poziomie razem
 * z nawigacją.
 *
 * Odbiorcy: tabela prób przy nieudanym odtwarzaniu i różnice importu listy.
 */

export function Table({ className, ...props }: React.ComponentProps<"table">) {
  return (
    <div data-slot="table-wrapper" className="w-full overflow-x-auto">
      <table
        data-slot="table"
        className={cn("w-full caption-bottom border-collapse text-sm", className)}
        {...props}
      />
    </div>
  );
}

export function TableHeader({ className, ...props }: React.ComponentProps<"thead">) {
  return (
    <thead
      data-slot="table-header"
      className={cn("text-left text-muted-foreground", className)}
      {...props}
    />
  );
}

export function TableBody({ className, ...props }: React.ComponentProps<"tbody">) {
  return <tbody data-slot="table-body" className={cn("align-top", className)} {...props} />;
}

export function TableRow({ className, ...props }: React.ComponentProps<"tr">) {
  return (
    <tr
      data-slot="table-row"
      className={cn("border-b border-border/50 transition-colors hover:bg-secondary/30", className)}
      {...props}
    />
  );
}

export function TableHead({ className, ...props }: React.ComponentProps<"th">) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        "border-b border-border py-2 pr-4 font-medium whitespace-nowrap last:pr-0",
        className,
      )}
      {...props}
    />
  );
}

export function TableCell({ className, ...props }: React.ComponentProps<"td">) {
  return <td data-slot="table-cell" className={cn("py-2 pr-4 last:pr-0", className)} {...props} />;
}
